import { supabase } from './supabase'

// EF-159b: resolve a workspace target for a typed-in symbol. Look up a
// non-closed position_project for (user, symbol); if found, return the path
// to the existing workspace. Otherwise return an ephemeral path that does
// NOT pre-create a row — the insert is deferred to Save Draft / Send Orders.
// Length 21 covers OCC option symbols.
const SYMBOL_RE = /^[A-Z0-9.\-/]{1,21}$/

export async function resolveSymbolWorkspace(userId, symbol) {
  if (!userId) throw new Error('User ID is required')

  const normalized = String(symbol ?? '').trim().toUpperCase()
  if (!normalized) throw new Error('Symbol is required')
  if (!SYMBOL_RE.test(normalized)) throw new Error('Invalid symbol')

  const { data: existing, error: lookupError } = await supabase
    .from('position_projects')
    .select('id')
    .eq('user_id', userId)
    .eq('symbol', normalized)
    .in('stage', ['active', 'working', 'idea', 'planned'])
    .order('created_at', { ascending: false })

  if (lookupError) throw new Error(lookupError.message)
  if (existing && existing.length > 0) {
    return {
      path: `/positions/workspace?symbol=${encodeURIComponent(normalized)}&projectId=${encodeURIComponent(existing[0].id)}`,
      action: 'opened_existing',
    }
  }

  return { path: `/positions/workspace?symbol=${encodeURIComponent(normalized)}`, action: 'ephemeral' }
}
